
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/profile/account/information",
      function () {
        return require("private-next-pages/profile/account/information.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/profile/account/information"])
      });
    }
  